const CHANNEL_METADATA_KEYS = ["channelId", "channelID", "channel_id", "channel"];

export const resolveEventChannelId = (event) => {
    if (!event || !event.metadata || typeof event.metadata !== "object") {
        return null;
    }
    for (let index = 0; index < CHANNEL_METADATA_KEYS.length; index += 1) {
        const key = CHANNEL_METADATA_KEYS[index];
        const value = event.metadata[key];
        if (value !== undefined && value !== null && value !== "") {
            return String(value);
        }
    }
    return null;
};

export const resolveScopedChannelId = (
    channelFilter,
    selectedChannelId,
    { isFilterExplicit = false } = {}
) => {
    if (channelFilter != null && channelFilter !== "") {
        return String(channelFilter);
    }
    if (isFilterExplicit) {
        return null;
    }
    if (selectedChannelId != null && selectedChannelId !== "") {
        return String(selectedChannelId);
    }
    return null;
};

export const scopeEventsToChannel = (events, { selectedChannelId } = {}) => {
    if (!Array.isArray(events)) {
        return [];
    }
    const selectedKey = selectedChannelId != null ? String(selectedChannelId) : null;

    return events.filter((event) => {
        const eventChannelId = resolveEventChannelId(event);
        if (eventChannelId == null) {
            return true;
        }
        if (selectedKey == null) {
            return true;
        }
        return eventChannelId === selectedKey;
    });
};
